const PubDateTypes = {
	all: {
		key: 0,
		label: 'None',
	},
	frontlist: {
		key: 1,
		label: 'Frontlist',
	},
	backlist: {
		key: 2,
		label: 'Backlist',
	},
	relativeTimeframe: {
		key: 3,
		label: 'Relative Timeframe',
	},
	absoluteTimeframe: {
		key: 4,
		label: 'Absolute Timeframe',
	},
};

export default PubDateTypes;
